// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__b1-OR","icon":"Badge_icon__uI6Lb","iconBackground":"Badge_iconBackground__toJMq"};